<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>

  <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
              <v-layout wrap>
                <div class="flex md12">
                  <v-text-field label="Ad" v-model="Web.Ad" :error-messages="errors.collect('gibseri')" v-validate="'required'"
                    data-vv-name="gibseri" required>
                  </v-text-field>
                  <v-text-field label="Açıklama" v-model="Web.Aciklama" required>
                  </v-text-field>
                </div>
              </v-layout>
 </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
              <v-btn id="bsil" color="blue darken-1" flat @click="deletekayit()">Sİl</v-btn>
            </div>

            <v-btn color="blue darken-1" flat @click="vazgec()">Vazgeç</v-btn>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>Web Adresi Tanımlama</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>

        <v-btn hidden="xs" flat @click="hesapekle()"> Web Adresi Ekle
          <v-icon right dark>add_box</v-icon>
        </v-btn>
      </v-toolbar>
    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items" :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.ID)" item>
            <td class="text-xs-left">{{ props.item.ID }}</td>
            <td class="text-xs-left">{{ props.item.Ad }}</td>
            <td class="text-xs-left">{{ props.item.Aciklama }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'İd',
            value: 'ID'
          },
          {
            text: 'Adı ',
            value: 'Ad'
          },
          {
            text: 'Açıklama ',
            value: 'Aciklama'
          }



        ],
        loading: false,
        progress: false,
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        addgib: false,

        Web: {
          ID: '',
          Aciklama: '',
          Ad: ''
        },
        state: [],
        dialog_baslik: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        bankakod: '',
        bankaadi: '',
        dictionary: {
          custom: {
            gibseri: {
              required: () => 'Bu alan boş bırakılamaz',
              max: () => 'İki karakterden fazla olamaz'
            },
            sirketadi: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Getir(v) {

        this.addgib = false
        this.k = false
        this.m = true
        this.$validator.reset()

        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Web Adresi Güncelle'
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          CompanyCode: credentials.SirketKodu,
          ID: v,
          Type: '305'
        }
        this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Web = response.body[0]
        })
      },
      deletekayit: deletekayit,
      hesapekle: hesapekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
  }



  function Kaydet() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.$validator.validateAll().then((result) => {
      if (result) {
        var params = {
          Explanation: this.Web.Aciklama,
          CompanyCode: credentials.SirketKodu,
          Name: this.Web.Ad,
          Type: '305'
        }

        this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.dialog = false
          var params1 = {
            CompanyCode: credentials.SirketKodu,
            type: '305'
          }
          this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable.'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable.'
              this.snackbar = true
            }
          })
        })
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      }
    })
  }





  function hesapekle() {

    this.dialog = true
    this.Web = {}
    this.addgib = true
    this.dialog_baslik = 'Web Adresi Ekle'
    this.m = false
    this.k = true
    this.$validator.reset()

  }

  function beforeMount() {
    this.progress = true
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params = {
      CompanyCode: credentials.SirketKodu,
      Type: '305'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.progress = false

        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.progress = false

        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }

  function deletekayit() {

    this.addgib = false
    if (window.confirm('Web Adresi\'ni silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var params = {
        CompanyCode: credentials.SirketKodu,
        ID: this.Web.ID,
        Type: '305'

      }
      this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          var params1 = {
            CompanyCode: credentials.SirketKodu,
            Type: '305'
          }
          this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {

    this.addgib = false
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          ID: this.Web.ID,
          Explanation: this.Web.Aciklama,
          CompanyCode: credentials.SirketKodu,
          Name: this.Web.Ad,
          Type: '305'
        }

        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeUpdate', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var params1 = {
              CompanyCode: credentials.SirketKodu,
              Type: '305'
            }
            this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>